import React from "react";
import {TextField} from "@mui/material";
const TextFieldJS = ({style, className, inputProps, placeholder, inputPropStyle}) =>{
    return <TextField
        className={className}
                    id="outlined-basic"
                    variant="outlined"
                    placeholder={placeholder}
                    style={{...style }}
                    InputProps={{
                        endAdornment: (
                            inputProps
                        ),
                        style:(inputPropStyle
                        )}
                    }
                  />
}
export default TextFieldJS;